// extracted by mini-css-extract-plugin
export default {"statistic":"statistic_statistic__qxq4N"};